exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_button{font-weight:600;letter-spacing:2px;padding:10px 16px;color:var(--text-dark-blue);border:2px solid var(--primary-dark-blue);text-align:center;-ms-flex-align:center;align-items:center;border-radius:20px !important;text-transform:uppercase;background-color:transparent;transition:0.2s ease-in;-o-transition:0.2s ease-in;-ms-transition:0.2s ease-in;-moz-transition:0.2s ease-in;-webkit-transition:0.2s ease-in}.common_button:hover{color:#fff;background-color:var(--primary-dark-blue)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/commonButton.scss
// module id = 1543
// module chunks = 0